<template>
  <div class="page" v-loading="loading">
    <!-- 顶部banner图 -->
    <div class="top-banner-box">
      <div class="top-banner-img">
        <div class="top-banner-center">
          <el-row type="flex" justify="space-between" align="middle" class="nav-row">
            <div class="left">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }" @click=""
                  >首页</el-breadcrumb-item
                >
                <el-breadcrumb-item
                  :to="{ path: '/demandInfoList' }"
                  @click=""
                  >全部需求</el-breadcrumb-item
                >
                <el-breadcrumb-item>{{detailData.demandName}}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="right">
              <!-- <div class="collection-btn">
                <div>icon</div>               
                <span>收藏</span>
              </div> -->
            </div>
          </el-row>
          <div class="project-row">
            <div class="avatar"></div>
            <div class="right-box">
              <div class="ability-wrap">
                <div class="ability" v-for="(item, i) in applicationSceneList" :key="i">
                    <span  class="abilityText">{{ item }}</span>
                </div>
              </div>
              <div class="title">{{detailData.demandName}}</div>
              <el-row type="flex" justify="space-between" align="middle" class="date-row">
                <div>需求编号：{{detailData.demandCode}}</div>
                <div>发布时间：{{detailData.createDate}}</div>
              </el-row>
              <div class="budget-row">
                <div class="">需求预算 <span class="num">{{setBudGetText(detailData, '￥')}}</span></div>
                <div class="">剩余时间 <span class="num" v-if="countdownText">{{countdownText}}</span><span v-if="!countdownText" class="num grey">已截至</span></div>
                <div class="">已响应次数 <span class="num">{{ detailData.useCount }}次</span></div>
              </div>
              <div v-if="!isResponse" :class="{'btn': true, 'disabled': !countdownText}" @click="doResponse">我要响应</div>
              <div v-else class="btn disabled">已响应</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module main">
      <el-row type="flex" justify="space-between"  class="detail-content">
        <div class="tabs-wrap">
          <!-- <div class="tabs">
            <div class="tabs-item">
              <a href="#detail">需求详情</a>
            </div>
            <div class="tabs-item">
              <a href="#attachment">附件信息</a>
            </div>
            <div class="tabs-item">
              <a href="#project">项目信息</a>
            </div>
            <div class="tabs-item">
              <a href="#buyer">买家信息</a>
            </div>
          </div> -->
          <el-tabs v-model="tabName" class="tabs-nav" @tab-click="handleTabClick">
            <template v-for="(tab, index) of tabs">
              <el-tab-pane  :label="tab.title" :name="tab.refName"></el-tab-pane>
            </template>
          </el-tabs>

          <div id="detail" class="tabs-item">
            <div class="tabs-title">需求详情</div>
            <div class="tabs-content">
              {{detailData.remark}}
            </div> 
          </div>
          <div id="attachment" class="tabs-item">
            <div class="tabs-title">附件信息</div>
            <div class="tabs-content">
              附件：<a
                    v-for="item in detailData.demandFileList"
                    :key="item.uuid"
                    :href="item.file"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="file-text"
                  >{{ item.fileName }} </br></a>
            </div>
          </div>
          <div id="project" class="tabs-item">
            <div class="tabs-title">项目信息</div>
            <div class="tabs-content">
              项目地址：{{detailData.programProvice}}-{{detailData.programCity}}-{{detailData.programArea}}-{{detailData.programAddr}} </br> 
              发布时间：{{detailData.createDate }} </br>
              截止时间：{{detailData.endDate }}
            </div>
          </div>
          <div id="buyer" class="tabs-item">
            <div class="tabs-title">买家信息</div>
            <div class="tabs-content">
              <div v-if="!isResponse" class="btn" @click="enterServeic">入驻成为服务商，点击【我要响应】即可查看买家信息</div>
              <template v-else>
                联系人：{{detailData.contact}} </br>
                联系电话：{{detailData.telPhone}} </br>
                联系地址：{{detailData.contactProvice}}-{{detailData.contactCity}}-{{detailData.contactArea}}</br>
              </template>
            </div>
          </div>
          <div class="tabs-item">
            <div class="tabs-title" style="margin-bottom: 0;">需求流程</div>
            <div class="tabs-content">
              <div>
                <img src="~@/assets/image/demandInfoDetail_process.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="related-box" v-loading="relatedLoading">
          <div class="title-row">
            <div class="title">相关需求</div>
            <div class="btn" @click="getDemandInfoList">换一批</div>
          </div>
          <div class="project-content" v-if="demandInfoList.length>0">
            <div class="project-item" v-for="item in demandInfoList">
              <div class="title">{{item.demandName}}</div>
              <div class="text">需求方：{{ item.companyName }}</div>
              <div class="introduction">
                需求内容：{{item.remark}}
              </div>
              <div class="text">截止时间：{{item.endDate}}</div>
              <div class="text">响应次数：{{item.useCount}}次</div>
              <div class="text">公司地址：<span>{{item.programProvice}}-{{item.programCity}}-{{item.programArea}}-{{item.programAddr}}</span></div>
              <div class="btn-row">
                <div class="btn" @click.stop="goDetail(item)">查看详情</div>
              </div>
            </div>
          </div>
          <div v-else class="empty-box">暂无数据</div>
        </div>
      </el-row>
    </div>
    <div class="module" v-if="serviceProviderList.length > 0">
      <div class="module-title">推荐服务商</div>
      <div class="module-content provider">
        <div class="provider-item" v-for="item in serviceProviderList" :key="item.uuid" @click="goServiceDetailPage(item.uuid)" :title="item.unitName">{{item.unitName}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDictionaryItem } from "../../utils/interface";
import demandInfoNews from "@/components/newsConsult/demandInfoNews";
import serviceProvider2 from "@/components/resourcePool/serviceProvider2";
import { demandInfoDetail, demandInfoQuery, demandInfoIsResponse, demandInfoDoResponse, unitDetailsInfoList } from "@/utils/honorApi";
import { setBudGetText } from "@/utils/filter";
export default {
  name: "",
  components: { demandInfoNews, serviceProvider2 },
  props: {},
  data() {
    return {
      uuid: '',
      detailData: null,
      applicationSceneList: [],
      countdownText: '',
      timer: null,
      loading: false,
      relatedLoading: false,
      doResponseLoading: false,
      serviceProviderList: [],
      activeName: 'demand',
      isResponse: false, // 是否响应
      tabs: [
				{ title: "需求详情", refName: "demand" },
				{ title: "附件信息", refName: "attachment" },
				{ title: "项目信息", refName: "project" },
				{ title: "买家信息", refName: "buyer" },
			],
      contentStyleObj: {
				height: "100px"
			},
			scrollItems: [], //滚动项
			isScroll: true, //是否处于滚轮手动滚动中
      params: {
        current: 1,
        pageSize: 16,
        total: 0,
      },
      headerBgUrl: "",
      serviceList: [],
      num: 168,
      profile:
        "汇聚一批不同行业、领域资深专家，充分发挥专家队伍的优势，为我区数字化\n" +
        "转型工作提供智力支持和技术保障，为政策制定、评估诊断、专项培训、供需\n" +
        "对接提供专业支撑，进一步促进我区新型工业化纵深发展",
      title: "",
    };
  },
  watch: {
    // 监听路由变化，重新加载数据
    '$route'(to, from) {
      if (to.query.id !== from.query.id) {
        this.isResponse = false;
        this.loadDetail();
      }
    }
  },
  computed: {},
  beforeRouteEnter(to, from, next) {
    // console.log("to=>", to)
    // console.log("from=>", from)
    // console.log("next=>", next)
    next(vm => {
      if (from.name == "expertDetail") {
        vm.$nextTick(() => {
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        });
      }
    });
  },
  beforeDestroy() {
    console.log('beforeDestroy')
    if (this.timer) clearInterval(this.timer);
  },
  created() {
    this.loadDetail();
	},
	mounted() {
	},
	destroyed() {
		window.removeEventListener("resize", this.getHight);
	},
  mounted() {
		this.scrollItems = document.querySelectorAll(".scroll-item");
    window.addEventListener("scroll", this.menu);
    if (this.$route.query.type || this.$route.query.code) {
      let type = this.$route.query.type;
      let code = this.$route.query.code;
      if (type == "expert" || code == "2") {
        this.timer = setInterval(() => {
          // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
          let length = document.querySelectorAll(".changeColor").length;
          if (length > 0) {
            clearInterval(this.timer);
            window.scrollTo({
              top: document.getElementById("field").offsetTop - 80,
              behavior: "smooth"
            });
          }
        });
      }
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        }
      });
    }
  },
  methods: {
    setBudGetText,
    // 入驻服务商
    enterServeic() {
      if (!this.$store.state.isLogin) {
        this.$message.warning("您需要先登陆哦！")
        this.$router.push("/login");
      } else {

      }
    },
    doResponse() {
      console.log('this.$store.state', this.$store.state);
      if (!this.$store.state.isLogin) {
        this.$message.warning("您需要先登陆哦！")
        this.$router.push("/login");
      } else {
        if (this.doResponseLoading) return;
        this.doResponseLoading = true;
        demandInfoDoResponse(this.uuid).then(res => {
          if (res.success) {
            this.isResponse = true;
            this.loadDetail();
            this.$message.success(res.message || '响应成功');
          } else {
            if (res.message.indexOf('已响应') > -1) {
              this.isResponse = true;
            } else {
              this.$message.error(res.message || '响应失败')
            }
          }
          console.log('demandInfoDoResponse', res);
        }).finally(_ => {
          this.doResponseLoading = false;
        })
      }
    }, 
    loadDetail() {
      const uuid = this.$route.query.id;
      if (!uuid) return;
      this.loading = true;
      this.uuid = uuid;
      // 清除之前的定时器
      if (this.timer) clearInterval(this.timer);
      // 使用 Promise.all 同时发起两个请求
      Promise.all([
        demandInfoIsResponse(this.uuid),
        demandInfoDetail(this.uuid)
      ]).then(([responseRes, detailRes]) => {
        // 处理第一个请求结果
        this.isResponse = responseRes;
        // 处理第二个请求结果
        if (detailRes.success) {
          this.detailData = detailRes.data;
          if (detailRes.data.applicationScene) {
            this.applicationSceneList = this.detailData.applicationScene.split(',');
          } 
          this.getServiceProviderList(); // 查询相似行业供应商
          this.startCountdown();
        }
      }).catch(error => {
        console.error('请求失败:', error);
        // 可以在这里添加错误处理逻辑
      }).finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      });
      
      this.getDemandInfoList();
    },
    getDemandInfoList() { // 随机相关需求
      if (this.relatedLoading) return;
      this.relatedLoading = true;
      let params = {
        status: 'REVIEW_PASS',
        isPass: '1',
        current: 1,
        pageSize: 999,
      }
      demandInfoQuery(params).then(res => {
        const filtered = res.list.filter(item => item.uuid !== this.uuid);
        // 如果没有数据，返回空数组
        if (filtered.length === 0) {
          this.demandInfoList = [];
        } else {
          const shuffled = [...filtered].sort(() => Math.random() - 0.5);
          this.demandInfoList = shuffled.slice(0, 2);
        }
      }).finally(_ => {
        this.relatedLoading = false;
      })
    },
    getServiceProviderList() {
      let params = {
        serviceIndustry: this.detailData.industryType || '',
        status: '3', // 1填报中 2待审核 3审核通过 4审核不通过
      }
      unitDetailsInfoList(params).then(res => {
        if (!Array.isArray(res) || res.length === 0) {
          this.serviceProviderList = [];
        } else {
          // 克隆数组并打乱顺序（Fisher-Yates 洗牌）
          const shuffled = [...res].sort(() => Math.random() - 0.5);
          // 截取前 8 个（或更少）
          this.serviceProviderList = shuffled.slice(0, 8);
        }
      })
    },
    goServiceDetailPage(uuid) {
      let routeData = this.$router.resolve({
        path: "/providerDetail",
        query: {
          uuid: uuid,
          type: "provider",
          titleName: "直播列表",
          titleForm: "providerDetail",
        },
      })
      window.open(routeData.href, "_blank")
    },
    goDetail(item) {
      this.$router.push({path: "/demandInfoDetail", query: { id: item.uuid }});
    },
    startCountdown() {
      // 启动每秒更新一次
      this.timer = setInterval(() => {
          if (!this.detailData.endDate) {
            this.countdownText = '';
            return;
          }
          const endTime = new Date(this.detailData.endDate).getTime();
          const now = new Date().getTime();
          const diff = endTime - now; // 毫秒差
          if (diff <= 0) {
            this.countdownText = ''; // 已过期，不显示
            return;
          }

          // 计算天、时、分、秒
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((diff / (1000 * 60)) % 60);
          const seconds = Math.floor((diff / 1000) % 60);

          // 格式化输出：只显示“X天X时X分X秒”，但你可以按需简化
          let text = '';
          if (days > 0) {
            text += `${days}天`;
          }
          if (hours > 0) {
            text += `${hours}时`;
          }
          if (minutes > 0) {
            text += `${minutes}分`;
          }
          if (seconds > 0 || !text) { // 如果前面都没显示，至少保留秒
            text += `${seconds}秒`;
          }

          this.countdownText = text;
      }, 1000); // 每秒更新一次
    },
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "ZYC_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    // tab锚定
		handleTabClick(tab, event) {
			const targetId = tab.name;
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // 获取元素距离视口顶部的距离
        const rect = targetElement.getBoundingClientRect();
        // 当前页面已滚动的距离
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // 目标实际应滚动到的位置：元素顶部 - 80px（避开导航栏）
        const scrollToY = rect.top + scrollTop - 85;

        // 平滑滚动
        window.scrollTo({
          top: scrollToY,
          behavior: 'smooth'
        });
      }
		},
		getHight() {
			this.contentStyleObj.height = window.innerHeight - 175 + "px";
		}
  }
};
</script>
<style lang="less" scoped>
.red-text {
  color: #FF0000;
}
.page {
  position: relative;
  top: -80px;
  margin-bottom: -80px;
  background-color: #f0f4fa;
  padding-bottom: 16px;

  .top-banner-box {
    position: relative;
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      background: url('~@/assets/image/demandInfoDetail_top_bg.png') no-repeat;
      background-size: cover;
      .top-banner-center {
        width: 1300px;
        height: 370px;
        position: relative;
        top: 97px;
      }
      .collection-btn {
        width: 68px;
        height: 23px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 248px;
        background-color: #fff;
        font-size: 14px;
        color: #959595;
        cursor: pointer;
      }
      .btn-row {
        margin-left: 80px;
        // background-color: white;
        display: flex;  
        position: absolute;
        bottom: 45px;
        transition: all 0.2s;
      }
      .btn {
        margin-right: 15px;
        width: 166px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: normal;
        color: #3672F6;
        border-radius: 4px;
        opacity: 1;
        background: rgba(255, 255, 255, 0.4);
        box-sizing: border-box;
        border: 1px solid #3672F6;
        cursor: pointer;
        user-select: none;
        &:first-child {
          background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
          color: #FFFFFF;
        }
      }
    }
    .nav-row {
      margin-bottom: 30px;
    }
    .project-row {
      display: flex;
      .avatar {
        margin-right: 48px;
        width: 429px;
        height: 262px;
        border-radius: 10px;
        background-color: #f3f2f2;
        background-image: url('~@/assets/image/demandInfoDetail_avatar.png');
        background-repeat: no-repeat;
        background-size: contain;
      }
      .ability-wrap {
        display: flex;
        flex-wrap: wrap;
        .ability {
          margin-right: 8px;
          margin-bottom: 8px;
          height: 28px;
          padding: 0 10px;
          border-radius: 4px;
          opacity: 1;
          background: #DDE9FB;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-weight: 350;
          color: #2D50A1;
          white-space: nowrap; /* 禁止文本换行 */
          overflow: hidden; /* 隐藏超出范围的内容 */
          text-overflow: ellipsis; /* 使用省略号 */
        }
      }
      .title {
        margin: 2px 0 20px;
        font-size: 24px;
        font-weight: bold;
      }
      .date-row {
        margin-bottom: 8px;
        font-size: 16px;
      }
      .budget-row {
        margin-bottom: 35px;
        width: 690px;
        height: 59px;
        border-radius: 4px;
        background: #ddeaf5;
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-weight: 400;
        font-size: 16px;
        .num {
          font-weight: 500;
          font-size: 22px;
          color: #FF0000;
          &.grey {
            color: #797979;
          }
        }
      }
      .btn {
        width: 230px;
        height: 48px;
        border-radius: 4px;
        background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
        color: #FFFFFF;
        font-size: 18px;
        font-weight: 350;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

}
.module {
  width: 100%;
  margin: auto;
  box-sizing: border-box;
  background: #f0f4fa;
  &.main {
    position: relative;
  }
  .module-title {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    margin: 0 0 20px 0;
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;
    font-feature-settings: "kern" on;
    color: #2B2B2B;
  }
  .detail-content {
    width: 1300px;
    margin: 0 auto 0;
    position: relative;
    top: -60px;
  }
  .tabs-wrap {
    width: 946px;
    padding: 35px 30px 30px;
    border-radius: 10px;
    opacity: 1;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    .tabs-nav /deep/ .el-tabs__item {
      font-size: 18px;
    }
    .tabs-title {
      margin-bottom: 13px;
      font-size: 18px;
      font-weight: 500;
    }
    .tabs-item {
      margin-bottom: 34px;
      &:last-of-type{
        margin-bottom: 0;
      }
    }
    .tabs-content {
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
    }
    .file-text {
      color: #2D50A1;
      margin-left: 40px;
      padding: 0;
      &:first-of-type {
        margin-left: 0;
      }
    }
    .btn {
      width: 890px;
      height: 60px;
      opacity: 1;
      background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%), #D8D8D8;
      font-size: 18px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .related-box {
    padding: 30px 28px 25px;
    width: 337px;
    height: 696px;
    border-radius: 10px;
    opacity: 1;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    .title-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px solid #CBCBCB;
      .title {
        font-size: 24px;
        font-weight: bold;
      }
      .btn {
        font-size: 14px;
        font-weight: normal;
        color: #2D50A1;
      }
    }
    .project-content {
      display: flex;
      flex-wrap: wrap;
    }
    .project-item {
      position: relative;
      // width: 310px;
      // height: 392px;
      height: 311px;
      width: 100%;
      padding: 20px 0;
      opacity: 1;
      background: #FFFFFF;
      font-size: 14px;
      font-weight: 350;
      line-height: normal;
      color: #2B2B2B;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      border-bottom: 1px solid #CBCBCB;
      &:last-child { 
       border-bottom: 0;
      }
      .title {
        margin: 0 0 3px;
        font-size: 18px;
        font-weight: bold;
        line-height: normal;
        white-space: nowrap; /* 文本不会换行，会在同一行内继续，直到遇到<br>标签为止 */
        text-overflow: ellipsis; /* 当文本溢出包含它的容器时，显示省略号(...)来表示被截断的文本 */
        overflow: hidden; /* 隐藏溢出容器的文本 */
      }
      .introduction {
        padding: 11px 11px 14px;
        width: 276px;
        height: 58px;
        border-radius: 4px;
        background: #eaedf5;
        box-sizing: border-box;
        line-height: 1.53;
        display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
        -webkit-box-orient: vertical; /* 垂直排列 */
        -webkit-line-clamp: 2; /* 限制显示三行 */
        overflow: hidden; /* 隐藏超出范围的内容 */
        text-overflow: ellipsis; /* 使用省略号 */
      }
      .text {
        display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
        -webkit-box-orient: vertical; /* 垂直排列 */
        -webkit-line-clamp: 1; /* 限制显示两行 */
        overflow: hidden; /* 隐藏超出范围的内容 */
        text-overflow: ellipsis; /* 使用省略号 */
      }
      .btn-row {
        padding-top: 14px;
        .btn {
          width: 100%;
          height: 48px;
          border-radius: 4px;
          background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  .module-content {
    width: 1300px;
    padding: 30px 30px 0;
    margin: 0 auto 30px;
    border-radius: 10px;
    background: #fff;
    box-sizing: border-box;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    &.provider {
      padding-left: 0;
      padding-right: 0;
      background-color: transparent;
      box-shadow: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .provider-item {
          width: calc(25% - 15px);
          height: 60px;
          margin-bottom: 30px;
          background-color: #fff;
          padding: 8px 18px;
          box-sizing: border-box;
          border-radius: 10px;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          line-height: 44px;
          cursor: pointer;
          white-space: nowrap; /* 禁止文本换行 */
          overflow: hidden; /* 隐藏超出范围的内容 */
          text-overflow: ellipsis; /* 使用省略号 */
          transition: transform 0.3s ease, box-shadow 0.3s ease; /* 平滑过渡 */
          transform-origin: center; /* 缩放中心点 */
          &:hover {
            transform: scale(1.15); /* 放大 5% */
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* 可选：加阴影增强效果 */
            z-index: 1; /* 确保放大后在上层（如果需要） */
          }
      }
    }
    .module-title {
      margin-top: 42px;
    }
    .more-btn {
      margin: 0 auto;
      width: 200px;
      height: 50px;
      border-radius: 4px;
      opacity: 1;
      background: #FFFFFF;
      box-sizing: border-box;
      border: 1px solid #2D50A1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #2D50A1;
      font-size: 16px;
      font-weight: normal;
      cursor: pointer;
    }
    .project-content {
      width: 1300px;
      margin: 38px auto 0;
      display: flex;
      flex-wrap: wrap;
    }
    .project-item {
      margin-right: 9px;
      margin-bottom: 22px;
      position: relative;
      width: 310px;
      height: 392px;
      opacity: 1;
      background: #FFFFFF;
      font-size: 18px;
      font-weight: 350;
      line-height: normal;
      color: #2B2B2B;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      border: 1px solid rgba(106, 106, 106, 0.2);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      &:nth-of-type(4n) { 
        margin-right: 0;
      }
    }
    .flag {
      position: absolute;
      top: 0;
      right: 0;
      width: 70px;
      height: 25px;
      border-radius: 0px 8px 0px 8px;
      opacity: 1;
      background: linear-gradient(270deg, #B0B0B0 2%, #D3D3D3 100%);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      font-size: 14px;
      font-weight: 350;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      &.active {
        background: linear-gradient(270deg, #FF0000 0%, #FF7B00 100%);
      }
    }
    .title {
      margin: 3px 0;
      font-size: 24px;
      font-weight: bold;
      line-height: normal;
      white-space: nowrap; /* 文本不会换行，会在同一行内继续，直到遇到<br>标签为止 */
      text-overflow: ellipsis; /* 当文本溢出包含它的容器时，显示省略号(...)来表示被截断的文本 */
      overflow: hidden; /* 隐藏溢出容器的文本 */
    }
    .introduction {
      padding: 8px 9px;
      width: 100%;
      height: 94px;
      border-radius: 4px;
      background: #eaedf5;
      box-sizing: border-box;
      display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
      -webkit-box-orient: vertical; /* 垂直排列 */
      -webkit-line-clamp: 3; /* 限制显示两行 */
      overflow: hidden; /* 隐藏超出范围的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
    }
    .btn-row {
      padding-top: 14px;
      border-top: 1px solid #CBCBCB;
      .btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.btn {
  cursor: pointer;
  &.disabled {
    background: #959595 !important;
    border: 1px solid #eee !important;
    pointer-events: none;
    cursor: none;
  }
}
.empty-box {
  height: 300px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a2a2a2;
}
/deep/ .el-carousel__arrow--left {
  left: 90px;
}

/deep/ .el-carousel__arrow--right {
  right: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/demandInfo/demandInfoDetail.vue